"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const v4_1 = require("zod/v4");
exports.TaskSchema = v4_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.Xlsx2Csv2TransformationConvertRangeSchema.omit({
        srcDataTape: true,
    }).extend({
        srcArtifactSlug: v4_1.z.string(),
    }),
    tape_sanitizer_1.Xlsx2Csv2TransformationExtractValuesSchema.omit({
        srcDataTape: true,
    }).extend({
        srcArtifactSlug: v4_1.z.string(),
    }),
]);
exports.UiConfigSchema = v4_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.Xlsx2Csv2TransformationConvertRangeSchema.omit({
        srcDataTape: true,
    }),
    tape_sanitizer_1.Xlsx2Csv2TransformationExtractValuesSchema.omit({
        srcDataTape: true,
    }),
]);
exports.nodeType = 'operation_xlsx2csv2';
//# sourceMappingURL=types.js.map